module.exports = __webpack_public_path__ + "static/media/Cadmus.9b2e838a.jpg";